const PRIVACY_POLICY_PATTERN = new RegExp('{privacyPolicyUrl}', 'g');
const TERMS_AND_CONDITIONS_PATTERN = new RegExp('{termsAndConditionsUrl}', 'g');

class PlaceholderService {

  constructor(httpService, requestBuilder) {

    this.httpService = httpService;
    this.requestBuilder = requestBuilder;

  }

  initialisePlaceholderService() {

    let privacyPolicyUrlRequest = this.requestBuilder.getPrivacyPolicyUrlRequest();
    let termsAndConditionsUrlRequest = this.requestBuilder.getTermsAndConditionsUrlRequest();

    this.translationMap = {};

    return Promise.all(
      [
        this.httpService.get(privacyPolicyUrlRequest)
          .then((response) => {
            this.privacyPolicyUrl = response.data;
          }),
        this.httpService.get(termsAndConditionsUrlRequest)
          .then((response) => {
            this.termsAndConditionsUrl = response.data;
          })
      ]
    );

  }

  decorateString(str) {

    str = str.replace(PRIVACY_POLICY_PATTERN, this.privacyPolicyUrl);
    str = str.replace(TERMS_AND_CONDITIONS_PATTERN, this.termsAndConditionsUrl);

    return str;

  }

}

export default PlaceholderService;
